/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2024 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import * as o from "react";
import { footerColumns as f, resolveCells as u } from "../utils/index.mjs";
import { classNames as C } from "@progress/kendo-react-common";
import { tableKeyboardNavigationTools as g, useTableKeyboardNavigation as b } from "@progress/kendo-react-data-tools";
const k = (t) => {
  const { column: e, index: l, isRtl: r, id: c, cells: s } = t, d = b(c), a = {
    colSpan: e.colSpan !== 1 ? e.colSpan : void 0,
    style: e.left !== void 0 ? r ? { left: e.right, right: e.left } : { left: e.left, right: e.right } : {},
    className: C(
      "k-table-td",
      e.locked && e.left !== void 0 ? "k-grid-footer-sticky" : ""
    ),
    key: l,
    role: "gridcell",
    "aria-colindex": e.ariaColumnIndex,
    ...d
  }, n = {
    field: e.field,
    ariaColumnIndex: e.ariaColumnIndex,
    ...a
  }, i = u(s, e.cells);
  if (i && i.footerCell) {
    const m = i.footerCell;
    return /* @__PURE__ */ o.createElement(m, { ...n, tdProps: a, index: l });
  }
  return e.footerCell && /* @__PURE__ */ o.createElement(e.footerCell, { ...n, key: l }) || /* @__PURE__ */ o.createElement("td", { ...a });
}, I = (t) => /* @__PURE__ */ o.createElement("tr", { className: "k-table-row", role: "row", "aria-rowindex": t.ariaRowIndex }, f(t.columns).map((e, l) => {
  const r = g.generateNavigatableId(`${l}-footercell`, t.idPrefix, "nodata");
  return /* @__PURE__ */ o.createElement(
    k,
    {
      key: r,
      column: e,
      id: r,
      index: l,
      cells: t.cells,
      isRtl: t.isRtl
    }
  );
}));
export {
  I as FooterRow
};
